export var blockEditActions;
(function (blockEditActions) {
    blockEditActions["ADD"] = "blockEdit:ADD";
    blockEditActions["REMOVE"] = "blockEdit:REMOVE";
    blockEditActions["CLEAR"] = "blockEdit:CLEAR";
    blockEditActions["SAVING"] = "blockEdit:SAVING";
    blockEditActions["TOGGLE_EDIT"] = "blockEdit:TOGGLE_EDIT";
    blockEditActions["TOGGLE_DRAG"] = "blockEdit:TOGGLE_DRAG";
    blockEditActions["RESET"] = "blockEdit:RESET";
})(blockEditActions || (blockEditActions = {}));
